import useSWR from 'swr';
import { analyticsService, MachinesResponse } from '../services/analyticsService';

interface UseAnalyticsMachinesReturn {
  machines: MachinesResponse | undefined;
  loading: boolean;
  error: Error | undefined;
}

export const useAnalyticsMachines = (year: number): UseAnalyticsMachinesReturn => {
  const { data, error, isLoading } = useSWR<MachinesResponse, Error>(
    `/api/v1/analytics/service/machines?year=${year}`,
    () => analyticsService.getMachines(year),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      dedupingInterval: 5000,
    }
  );

  return {
    machines: data,
    loading: isLoading,
    error,
  };
};
